// src/GetSeatInfo.js
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './GetSeatInfo.css';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from './firebase';

function GetSeatInfo({ closeModal, showNotification }) {
  const [theaterNumber, setTheaterNumber] = useState('');
  const [seatNumber, setSeatNumber] = useState('');
  const [date, setDate] = useState(null);
  const [results, setResults] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const resultsPerPage = 3;

  const handleSearch = async () => {
    if (!theaterNumber.trim()) {
      showNotification('Please enter theater number.', 'error');
      return;
    }

    try {
      const issuesRef = collection(db, 'issues');
      let q = query(
        issuesRef,
        where('theaterNumber', '==', Number(theaterNumber))
      );

      if (seatNumber.trim()) {
        q = query(q, where('seatNumber', '==', seatNumber.trim()));
      }

      if (date) {
        const formattedDate = date.toISOString().split('T')[0];
        q = query(q, where('dateReported', '==', formattedDate));
      }

      const querySnapshot = await getDocs(q);
      const issues = [];
      querySnapshot.forEach((doc) => {
        issues.push({ id: doc.id, ...doc.data() });
      });

      setResults(issues);
      setCurrentPage(1);
    } catch (error) {
      console.error('Error fetching documents: ', error);
      showNotification('Failed to fetch data. Please try again.', 'error');
    }
  };

  // Pagination logic
  let paginatedResults = [];
  let totalPages = 0;

  if (results && results.length > 0) {
    totalPages = Math.ceil(results.length / resultsPerPage);
    const indexOfLastResult = currentPage * resultsPerPage;
    const indexOfFirstResult = indexOfLastResult - resultsPerPage;
    paginatedResults = results.slice(indexOfFirstResult, indexOfLastResult);
  }

  return (
    <div>
      <input
        type="number"
        value={theaterNumber}
        onChange={(e) => setTheaterNumber(e.target.value)}
        placeholder="Theater Number"
        required
      />
      <input
        type="text"
        value={seatNumber}
        onChange={(e) => setSeatNumber(e.target.value)}
        placeholder="Seat Number (Optional)"
      />
      <div style={{ marginTop: '10px' }}>
        <label htmlFor="date-picker">
          Select Date <span style={{ fontStyle: 'italic' }}>(Optional)</span>:
        </label>
        <DatePicker
          id="date-picker"
          selected={date}
          onChange={(date) => setDate(date)}
          dateFormat="yyyy-MM-dd"
          isClearable
          placeholderText="Any date"
          className="date-picker-input"
          popperPlacement="auto"
          autoComplete="off"
        />
      </div>
      <button onClick={handleSearch}>Search</button>
            {results && (
        <div>
          {results.length > 0 ? (
            <>
              <div className="results-container scrollable">
                {paginatedResults.map((issue) => (
                  <div key={issue.id} className="issue-card">
                    <p>
                      <strong>Theater:</strong> {issue.theaterNumber}
                    </p>
                    <p>
                      <strong>Seat Number:</strong> {issue.seatNumber}
                    </p>
                    <p>
                      <strong>Date Reported:</strong> {issue.dateReported}
                    </p>
                    <p>
                      <strong>Comment:</strong> {issue.comment}
                    </p>
                    <p>
                      <strong>Resolved:</strong> {issue.resolved ? 'Yes' : 'No'}
                    </p>
                    {issue.resolved && (
                      <>
                        <p>
                          <strong>Date Resolved:</strong> {issue.dateResolved}
                        </p>
                        <p>
                          <strong>Resolution Comment:</strong> {issue.commentResolved}
                        </p>
                      </>
                    )}
                  </div>
                ))}
              </div>
              {totalPages > 1 && (
                <div className="pagination">
                  <button
                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    onClick={() =>
                      setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          ) : (
            <p>No issues found.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default GetSeatInfo;
